module.exports = __webpack_public_path__ + "img/invite.cf53114d.png";